import React, {useState} from 'react';
import * as S from './SingleSelection.styles';
import ThemeToggler from '../ThemeToggler/ThemeTogglerUI';
import Icon from '../IconsSelector';

interface ISingleSelection {
  bc: string;
  fc: string;
  st: string;
  t: string;
  t_c: string;
  onToggle: Function;
  isActive: boolean;
}


const SingleSelection: React.FC<ISingleSelection>  = ({
  bc = '',
  fc = '',
  st = '',
  t = '',
  t_c = '',
  onToggle = () => { },
  isActive = false
}) => {
  const updateFilter = () => {
    onToggle({type: 'sf', fc})
  }
  return (
    <li onClick={() => {}}>
      <S.SegmentLabel green={bc}>
        <Icon
          name={''}
          // iconWidth={width}
          // iconHeight={height}
          // margin={margin}
        />
        <span>{t}</span>
      </S.SegmentLabel>
      <div className="segmentInfo">
        <p>{st}</p>
        <ThemeToggler
          onToggle={updateFilter}
          isActive={isActive}
        />
      </div>
    </li>
  );
};

export default SingleSelection;